import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fz-user-game-profile-shell',
  template: '<fz-user-game-profile-layout></fz-user-game-profile-layout>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserGameProfileFeaturesShellComponent {}
